export const CLEAR_STATEMENT = 'CLEAR_STATEMENT';
export const CLEAR_STATEMENTS = 'CLEAR_STATEMENTS';
export const CLEAR_STATE = 'CLEAR_STATE';

export const DELETE_STATEMENT = 'DELETE_STATEMENT';
export const DELETE_STATEMENT_ERROR = 'DELETE_STATEMENT_ERROR';
export const DELETE_STATEMENT_SUCCESS = 'DELETE_STATEMENT_SUCCESS';

export const GET_STATEMENTS = 'GET_STATEMENTS';
export const GET_STATEMENTS_ERROR = 'GET_STATEMENTS_ERROR';
export const GET_STATEMENTS_SUCCESS = 'GET_STATEMENTS_SUCCESS';

export const GET_STATEMENT = 'GET_STATEMENT';
export const GET_STATEMENT_ERROR = 'GET_STATEMENT_ERROR';
export const GET_STATEMENT_SUCCESS = 'GET_STATEMENT_SUCCESS';

export const SAVE_STATEMENT = 'SAVE_STATEMENT';
export const SAVE_STATEMENT_ERROR = 'SAVE_STATEMENT_ERROR';
export const SAVE_STATEMENT_SUCCESS = 'SAVE_STATEMENT_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/BankStatement/constants.js